import React from "react";
import { useRef, useState } from "react";

// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useTheme,
  Box,
} from "@mui/material";
import { isString } from "lodash";
import Iconify from "../../Iconify/Iconify";
import { Delete, Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function TableItemMoreMenu(props: any) {
  const {
    rowActions,
    row,
    setInsideRow,
    rowIndex,
    onRowDelete,
    onRowEdit,
    defaultRowActions,
  } = props;
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      {rowActions?.length > 4 ? (
        <>
          <IconButton ref={ref} onClick={() => setIsOpen(true)}>
            ...
          </IconButton>

          <Menu
            open={isOpen}
            anchorEl={ref.current}
            onClose={() => setIsOpen(false)}
            PaperProps={{
              sx: { width: 200, maxWidth: "100%" },
            }}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            {rowActions.map((item: any, index: number) => (
              <MenuItem
                key={index}
                sx={{ color: item.color || "text.secondary" }}
                onClick={() => {
                  item.onPress && item.onPress(row);
                  setIsOpen(false);
                }}
              >
                <ListItemIcon>
                  {isString(item.icon) ? (
                    <Iconify icon={item.icon} />
                  ) : (
                    item.icon(row)
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={item?.text || item?.tooltip}
                  primaryTypographyProps={{ variant: "body2" }}
                />
              </MenuItem>
            ))}
          </Menu>
        </>
      ) : (
        <Box sx={{ whiteSpace: "nowrap" }}>
          {rowActions?.map((item: any, index: number) => (
            <Tooltip key={index} title={item.tooltip || item.text}>
              <IconButton
                sx={{ color: item.color || "text.secondary" }}
                onClick={() => {
                  item.onPress && item.onPress(row);
                }}
              >
                {isString(item.icon) ? (
                  <Iconify icon={item.icon} />
                ) : (
                  item.icon(row)
                )}
              </IconButton>
            </Tooltip>
          ))}

          {defaultRowActions && (
            <Box sx={{ whiteSpace: "nowrap" }}>
              <Tooltip title={t("update")}>
                <IconButton
                  onClick={() => {
                    onRowEdit(row, rowIndex, setInsideRow);
                  }}
                >
                  <Iconify
                    icon="eva:edit-fill"
                    color={theme.palette.primary.main}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title={t("delete")}>
                <IconButton
                  onClick={() => {
                    onRowDelete(row, rowIndex, setInsideRow);
                  }}
                >
                  <Iconify
                    icon="eva:trash-2-outline"
                    color={theme.palette.error.main}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
